<template>
  <div class="modal fade contact-modal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" ref="modalElement">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            {{ isEditing ? 'Editar Utilizador' : 'Adicionar Novo Utilizador' }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div class="account-content">
            <form @submit.prevent="handleSave" class="account-wrap">
              <div class="form-group mb-24 icon">
                <input type="text" v-model="userForm.name" class="form-control" placeholder="Nome Completo" />
                <img src="../../assets/images/icon/user-square.svg" alt="user" />
              </div>

              <div class="form-group mb-24 icon">
                <input type="email" v-model="userForm.email" class="form-control" placeholder="Email" required />
                <img src="../../assets/images/icon/sms.svg" alt="email" />
              </div>

              <div class="form-group mb-24 icon" v-if="!isEditing">
                <input type="password" v-model="userForm.password" class="form-control" placeholder="Senha" required
                  minlength="6" />
                <img src="../../assets/images/icon/key.svg" alt="password" />
              </div>

              <div class="form-group mb-24">
                <select v-model="userForm.role" class="form-select" required>
                  <option value="ADMIN">ADMIN</option>
                  <option value="SUPERADMIN">SUPERADMIN</option>
                </select>
              </div>

              <div v-if="error" class="alert alert-danger">{{ error }}</div>

              <div class="form-group">
                <button type="submit" class="default-btn" :disabled="loading">
                  {{ loading ? 'A guardar...' : 'Guardar Utilizador' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';
import usersService from '../../services/usersService';

export default {
  name: 'ContactModal',
  props: {
    editUserData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      userForm: {
        name: '',
        email: '',
        password: '',
        role: 'ADMIN',
      },
      loading: false,
      error: null,
    };
  },
  computed: {
    isEditing() {
      return !!this.editUserData;
    },
  },
  watch: {
    editUserData: {
      handler(newVal) {
        if (newVal) {
          this.userForm = {
            name: newVal.name || '',
            email: newVal.email || '',
            role: newVal.role || 'ADMIN',
          };
        } else {
          this.resetForm();
        }
      },
      immediate: true,
    },
  },
  methods: {
    resetForm() {
      this.userForm = {
        name: '',
        email: '',
        password: '',
        role: 'ADMIN',
      };
      this.error = null;
    },
    async handleSave() {
      this.loading = true;
      this.error = null;

      try {
        if (this.isEditing) {
          await usersService.update(this.editUserData.id, {
            name: this.userForm.name,
            email: this.userForm.email,
            role: this.userForm.role,
          });
        } else {
          await usersService.create(this.userForm);
        }

        this.$emit('user-saved');
        this.resetForm();

        // Fechar o modal usando a API do Bootstrap
        const modal = bootstrap.Modal.getInstance(this.$refs.modalElement);
        if (modal) modal.hide();
      } catch (err) {
        this.error = err.response?.data?.message || 'Erro ao guardar utilizador';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.contact-modal {
  .modal-content {
    padding: 30px;
    border-radius: 20px;
    border: none;
  }

  .modal-header {
    border-bottom: 1px solid #ebf1ff;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }

  .form-group.icon {
    position: relative;

    input {
      padding-left: 45px;
    }

    img {
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;
    }
  }
}
</style>
